import { useSearchParams } from 'react-router-dom';
import { OnlineOrderList, OfflineOrderList } from '@/containers';
import { PageContainer } from '@/components/organisms';
import { PageHeader, ButtonIcon } from 'pepsico-ds';
import { useState, useEffect } from 'react';
import { Tab, TabsNavigation, Icon } from '@/components/atoms';
import { useSelector } from 'react-redux'; // Import useSelector
import { selectCountryCode } from '@/store/slices/countryCodeSlice'; // Import selector for countryCode
import { countryNameMapping } from '@/utils/constants/countryConstants';
import "./_online.Order.scss"

export const OnlineOrder = () => {
  const countryCode = useSelector(selectCountryCode); // Get countryCode from Redux store



  const countryName = countryNameMapping[countryCode]; // Get country name based on countryCode

  return (
    <div>
      <div className="page-header-container">
        <PageHeader
          title="Orders"
          toolbar={
            <div className="flex items-center">
              <div className="flex flex-col items-right mr-5">
                <div className="header-right-title">Selected Market</div>
                <div className="header-right-sub-title text-right">{countryName}</div>
              </div>
              <ButtonIcon icon="storefront" size="medium" className="marketplace-icon" />
            </div>
          }
        />
      </div>
      <PageContainer data-testid="online-order-page-content">
        <OnlineOrderTableEmbeddedInNavigation />
        <span className="ordersSettingsIcon absolute h-8 w-8 rounded p-2 mr-5">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>
      </PageContainer>
    </div>
  );
};

const OnlineOrderTableEmbeddedInNavigation = () => {
  const [selectedTabIndex, setSelectedIndex] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  // Map query parameter "type" to tab index
  const tabMapping = {
    online: 0,
    offline: 1,
    rewards: 2,
    digitalCodes: 3,
  };

  useEffect(() => {
    const type = searchParams.get('type');
    if (type && tabMapping[type] !== undefined) {
      setSelectedIndex(tabMapping[type]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleNavigationUpdate = (newIndex) => {
    setSelectedIndex(newIndex);

    // Update the query parameter when the tab changes
    const type = Object.keys(tabMapping).find((key) => tabMapping[key] === newIndex);
    if (type) {
      setSearchParams({ type });
    }
  };

  return (
    <div className="orderPageContainer">
      <PageHeader title="Order List" className="data-table-container-title" />
      <TabsNavigation handleSetActiveTab={handleNavigationUpdate} activeTabIndex={selectedTabIndex}>
        <Tab className="text-white" label="Online" />
        <Tab className="text-white" label="Offline" />
      </TabsNavigation>
      {selectedTabIndex === 0 && <OnlineOrderList />}
      {selectedTabIndex === 1 && <OfflineOrderList />}
    </div>
  );
};